export enum HealthTeamTypeEnum {
	ESF = 70,
	EAP = 76,
}
